import React from "react";
import { Box } from "@mui/material";
import { ICorporateEvent } from "../../../../../interfaces/corporateEvent";
import IsMobile from "../../../../../hooks/isMobile";
import { iDetailListItemProps } from "../../../../../types/contentType";
import { getFromCms } from "../../../../../helpers/common";
import { useAppSelector } from "../../../../../hooks/storeHooks";
import useCorporateServiceOptions from "../../../../../hooks/useCorporateServiceOptions";
import { DATE_FORMAT_SLASH, fDate } from "../../../../../utils/formatTime";
import EventOtherFieldValue from "../../../../reusable-components/event-other-field-value/EventOtherFieldValue";
import CorporateEventDetailListItem from "../../../../reusable-components/b2b/corporate-event-detail-list-item/corporateEventDetailListItem";
import {
	formatBudget,
	formatEventDays,
	formatPaymentDays,
	formatServiceTypes,
} from "../../../../../utils/B2B/corporateEventsUtils";
import "./DetailsTabContent.scss";

interface DetailsTabContentProps {
	corporateEventDetail: ICorporateEvent;
}

const DetailsTabContent: React.FC<DetailsTabContentProps> = ({ corporateEventDetail }) => {
	const isMobile = IsMobile();
	const cms = useAppSelector((state) => state.events.cms);
	const serviceOptions = useCorporateServiceOptions();
	const serviceOthersNote = corporateEventDetail?.serviceOthersNote?.trim() || "";
	const serviceTypes = corporateEventDetail?.serviceTypes?.filter((code) => code !== "OTHERS");

	const getEventDetailList = (): iDetailListItemProps[] => {
		return [
			{
				title: "Event name",
				value: corporateEventDetail?.name,
			},
			{
				title: "Event type",
				value: getFromCms(corporateEventDetail?.serviceEventType?.value || "CORPORATE", cms),
			},
			{
				title: "Service type",
				detailListItemClass: "hasOtherField",
				renderValue: () => (
					<EventOtherFieldValue
						presetValue={formatServiceTypes(serviceTypes, serviceOptions, "")}
						otherText={serviceOthersNote}
						otherLabel="Other services"
					/>
				),
			},
			{
				title: "Start date",
				value: fDate(corporateEventDetail?.startDate, DATE_FORMAT_SLASH),
			},
			{
				title: "Event days",
				value: formatEventDays(corporateEventDetail?.numberOfDays),
			},
			{
				title: "Deadline to quote",
				value: fDate(corporateEventDetail?.externalDeadline, DATE_FORMAT_SLASH),
			},
			{
				title: "Budget",
				value: corporateEventDetail?.budget ? formatBudget(corporateEventDetail?.budget) : "N/A",
			},
			{
				title: (
					<>
						Payment terms <span style={{ fontSize: "12px" }}>(From Event Start Date)</span>
					</>
				),
				value: formatPaymentDays(corporateEventDetail?.paymentDays),
			},
		];
	};

	return (
		<Box className="detailsTabContent">
			{isMobile && (
				<CorporateEventDetailListItem
					title={getEventDetailList()[0]?.title}
					value={getEventDetailList()[0]?.value as string}
				/>
			)}
			<Box className="detailsGrid">
				{(isMobile ? getEventDetailList().slice(1) : getEventDetailList()).map((item, index) => (
					<CorporateEventDetailListItem
						key={index}
						title={item.title}
						value={item.value as string}
						renderValue={item.renderValue}
						detailListItemClass={item.detailListItemClass}
					/>
				))}
			</Box>
		</Box>
	);
};

export default DetailsTabContent;
